import React, {Component, useEffect, useState} from 'react';
import {Icons} from '../../../util/icons';
import * as fonts from '../../../util/fonts';
import "./styles.scss";
import ModalTemplate from '../../../components/modal/ModalTemplate';
import {Column, Row} from '../../../components/layout';
import AppButton from '../../../components/app-button';
import colors from '../../../util/colors';
import Icon from './../../../components/icon/Icon';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {strings} from '../../../util/strings';



interface ErrorPopupProps {
    show: boolean;
    setShowModal(value: any): void;
    refresh: any;
    labels: typeof strings.pt.permissions;
}

function ErrorPopup({
    show,
    setShowModal,
    refresh,
    labels,
}: ErrorPopupProps) {

    return (
      <div className="errorPopup-modal-content p-0">
        <ModalTemplate
          className="errorPopup-modal"
          show={show}
          onHide={() => {
            setShowModal(false);
            refresh();
          }}
          cross={true}
          hideFooter={true}
          size="sm">
          <Column className="errorPopup-column">
            <Row className="errorPopup-title-row">
              <div>
                <Icon
                  className="errorPopup-icon"
                  name={Icons.ALERT_PROBLEM}
                  width="18"
                  height="25"
                  color={colors.alertRed}
                />
              </div>
            </Row>
            <Row className="errorPopup-title-row">
              <p
                style={{...fonts.M, ...fonts.Bold, color: colors.alertRed}}
                className="p-errorPopup">
                {labels?.permissions_readingError}
              </p>
            </Row>
            <Row className="errorPopup-button">
              <AppButton
                onClick={() => {
                  setShowModal(false);
                  refresh();
                }}
                variant="secondary">
                {labels?.permissions_button_ok}
              </AppButton>
            </Row>
          </Column>
        </ModalTemplate>
      </div>
    );
    }

    const mapStateToProps = ({
        strings,
      }: any) => ({
        labels: strings.value.pt.permissions,
      });

      const mapDispatchToProps = (dispatch: any) => ({
      });      
  
    export default compose(
        connect(mapStateToProps, mapDispatchToProps)(ErrorPopup)
      );

